import React from 'react'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'
import { getPlaceholder } from './utils'

const SearchInput = ({ isOpenSuggestions, value, onChange, onSubmit, onFocus }) => (
  <form
    onSubmit={event => onSubmit({ event })}
    className={`search-engine-search-input ${isOpenSuggestions ? 'search-engine-search-input--open' : ''}`}
  >
    <figure className='search-engine-search-input__icon'>
      <img
        src={getStaticImage(!isOpenSuggestions ? '/icons/orange-brand/icon-search-grey.svg' : '/icons/orange-brand/icon-search-primary-dark.svg')}
        alt='Search'
      />
    </figure>
    <input
      className='search-engine-search-input__input'
      placeholder={lang(getPlaceholder({ isOpenSuggestions }))}
      value={value}
      onChange={({ target: { value } }) => onChange(value)}
      onFocus={onFocus}
    />
    {value ? (
      <button
        type='button'
        onClick={() => onChange('')}
        className='search-engine-search-input__icon-btn'
      >
        <figure className='search-engine-search-input__icon'>
          <img src={getStaticImage('/icons/orange-brand/icon-close-slim-grey.svg')} alt='Clean' />
        </figure>
      </button>
    ) : null}
  </form>
)

export default SearchInput
